import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from "./connection.service";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {AppConfig} from "../app.config";
import {Customer} from "../entities/Customer";
import {Job} from "../entities/Job";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class CustomerService {
  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/Customer/';
  }

  getAllCustomers(): Observable<Customer[]> {
    return this.requestInterceptor
      .get(this.apiUrl, this.getHeaders())
      .map(response => response.json() as Customer[]);
  }

  public getCustomer(customerNo : string) : Observable<Customer>
  {
    let url = this.apiUrl + customerNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Customer);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/customer.service.ts